import { createContext, useContext } from 'react';
import { QuizData } from '../typings';

type QuizContextType = {
  quizData: QuizData;
  updateQuizData: (data: QuizData) => void;
};

const QuizContext = createContext<QuizContextType | undefined>(undefined);

export const useQuizContext = () => {
  const context = useContext(QuizContext);
  if (context === undefined) {
    throw new Error('useQuizContext must be used within a QuizContextProvider');
  }
  return context;
};

export default QuizContext;
